import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import TextFieldGroup from '../../common/TextFieldGroup'
import axios from 'axios'
import { ToastsStore } from 'react-toasts'
import { Theme } from '../../../utils/Theme'
import { withStyles } from '@material-ui/styles'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Box, Button } from '@material-ui/core'
import Loading from '../../common/Loading'
import AuthLayout from '../../layout/AuthLayout'

const styles = Theme()

//TODO : USER Actions and Reducers for new-password-with-token

class NewPassword extends Component {
  constructor(props) {
    super(props)

    this.state = {
      email: '',
      newPassword: '',
      confirmPassword: '',
      errors: {},
      loading: true,
      validToken: null,
    }

    this.onChange = this.onChange.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
  }

  //TODO USE COMPONENT MOUNT TO CHECK ID TOKEN VALID
  componentDidMount() {
    const token = this.props.match.params.token
    axios
      .get(`/api/users/validate-password-token/${token}`)
      .then(res => {
        const { valid } = res.data

        //Valid Token
        this.setState({ loading: false, validToken: valid })
      })
      .catch(err => {
        this.setState({ loading: false, validToken: false })
      })
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors })
    }
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value })
  }

  onSubmit(e) {
    e.preventDefault()

    const passwordData = {
      email: this.state.email,
      token: this.props.match.params.token,
      newPassword: this.state.newPassword,
      confirmPassword: this.state.confirmPassword,
    }

    this.ResetUserPassword(passwordData)
  }

  ResetUserPassword(passwordData) {
    axios
      .post(`/api/users/new-password-with-token/${this.props.match.params.token}`, passwordData)
      .then(res => {
        ToastsStore.success('Password updated successfully,  please login')
        this.props.history.push('/login')
      })
      .catch(err => {
        const errors = err.response.data
        this.setState({ errors })
      })
  }

  render() {
    const { errors, validToken, loading } = this.state
    const { classes } = this.props

    return (
      <AuthLayout>
        <Box>
          <h4 className="u-mb-medium">Password Reset</h4>
          {loading && <Loading />}
          {!loading && validToken && errors.token && (
            <p className="u-pb-small u-text-center u-text-danger u-text-bold">{errors.token}</p>
          )}
          {!loading && validToken && !errors.token && (
            <form noValidate onSubmit={this.onSubmit}>
              <TextFieldGroup
                label="Email Address"
                type="email"
                name="email"
                error={errors.email}
                value={this.state.email}
                onChange={this.onChange}
              />

              <TextFieldGroup
                label="New Password"
                type="password"
                name="newPassword"
                error={errors.newPassword}
                onChange={this.onChange}
                value={this.state.newPassword}
              />

              <TextFieldGroup
                label="Confirm Password"
                type="password"
                name="confirmPassword"
                error={errors.confirmPassword}
                onChange={this.onChange}
                value={this.state.confirmPassword}
              />

              <Button
                onClick={this.onSubmit}
                className={`c-btn c-btn--fullwidth ${classes.buttonPrimary}`}
                variant={'contained'}
              >
                New Password
              </Button>
            </form>
          )}
          {!loading && !validToken && !errors.token && (
            <p className="u-pb-small u-text-center u-text-danger u-text-bold">
              Invalid password reset link. <br />
              <Link to={'/forgot-password'}>Request new reset password link.</Link>
            </p>
          )}
        </Box>
      </AuthLayout>
    )
  }
}

NewPassword.propTypes = {
  errors: PropTypes.object.isRequired,
  match: PropTypes.object,
  classes: PropTypes.object,
  history: PropTypes.object,
}

const mapStateToProps = state => ({
  errors: state.errors,
  theme: state.theme,
})

export default connect(mapStateToProps, {})(withStyles(styles)(NewPassword))
